const appState = {
  portfolio: [],
  notes: [],
  files: [],
  projects: [],
  dailyChores: [],
  user: {},
  splitwiseUser: {},
  apiCache: {},
};

export default appState;
